import FormattedMessage from 'I18n/components/FormattedMessage';
import { CARD_PAYMENT_TYPE } from '../constants/payments';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const externalProcessors = new Set(['none', 'quickbooks', 'xero']);
const commerceHubPaymentMethods = new Set(['ach', 'card', 'sepa', 'pads', 'bacs']);
const PaidWithCommerceHub = ({
  propertyDefinition,
  last4,
  paymentMethodType,
  bankOrIssuer
}) => {
  if (paymentMethodType === CARD_PAYMENT_TYPE) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWithCard",
      options: {
        bankOrIssuer,
        last4
      }
    });
  }
  const paymentMethodOption = propertyDefinition.options.find(option => option.value === paymentMethodType);
  if (paymentMethodOption) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWithBankAccount",
      options: {
        paymentMethodType: paymentMethodOption.label,
        last4
      }
    });
  }
  return null;
};
const PaidWithExternalProcessor = ({
  objectId,
  propertyDefinition,
  paymentMethodType,
  referenceNumber
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardPaymentHighlight.paymentHighlight.paidWith"
    }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
      objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
      objectId: objectId,
      property: propertyDefinition,
      value: paymentMethodType,
      getAdditionalPropertyValue: () => undefined
    }), referenceNumber ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [" ", referenceNumber]
    }) : null]
  });
};
const PaymentMethodFormatter = ({
  objectId,
  propertyDefinition,
  processorType,
  paymentMethodType,
  referenceNumber,
  last4,
  bankOrIssuer
}) => {
  const isExternalPayment = !processorType || externalProcessors.has(processorType);
  if (!paymentMethodType) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "formatted-payment-method",
    children: !isExternalPayment && commerceHubPaymentMethods.has(paymentMethodType !== null && paymentMethodType !== void 0 ? paymentMethodType : '') ? /*#__PURE__*/_jsx(PaidWithCommerceHub, {
      propertyDefinition: propertyDefinition,
      last4: last4,
      paymentMethodType: paymentMethodType,
      bankOrIssuer: bankOrIssuer
    }) : /*#__PURE__*/_jsx(PaidWithExternalProcessor, {
      objectId: objectId,
      propertyDefinition: propertyDefinition,
      paymentMethodType: paymentMethodType,
      referenceNumber: referenceNumber
    })
  });
};
export default PaymentMethodFormatter;